import { useState } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'
import { usePageAccess } from './usePageAccess'
import { PERMISSIONKEYS } from '../utils/Permissions.const'

const endpoint = '/api/record'

export function useRecords() {
  const { enabled } = usePageAccess(PERMISSIONKEYS.RECORDS)
  const [params, setParams] = useState({
    page: 1,
    pageSize: 20,
  })

  const queryFn = async () => {
    const { data } = await axios.get(endpoint, { params })
    return data
  }

  const { isLoading, data: response = {} } = useQuery({
    queryKey: [endpoint, params],
    queryFn,
    keepPreviousData: true,
    enabled,
  })

  const createRecord = (key, value) => {
    return axios.post(endpoint, { key, value })
  }

  return {
    isLoading,
    setParams,
    response,
    createRecord,
  }
}
